export const LATEST_CATALOGUE_PART_ID_KEY = 'latest_catalogue_part_id';

export function getLatestCataloguePartId() {
  if (typeof window === 'undefined') {
    return null;
  }

  return localStorage.getItem(LATEST_CATALOGUE_PART_ID_KEY);
}

export function setLatestCataloguePartId(partId) {
  if (typeof window === 'undefined' || !partId) {
    return;
  }

  localStorage.setItem(LATEST_CATALOGUE_PART_ID_KEY, partId);
}

export function clearLatestCataloguePartId() {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(LATEST_CATALOGUE_PART_ID_KEY);
}
